/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Cook_SubInputs */

const en_notify_cook_sub = /** @type {(inputs: Notify_Cook_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before a cook session, with the recipe`)
};

const de_notify_cook_sub = /** @type {(inputs: Notify_Cook_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor einer Kochsession, mit dem Rezept`)
};

/**
* | output |
* | --- |
* | "Before a cook session, with the recipe" |
*
* @param {Notify_Cook_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_cook_sub = /** @type {((inputs?: Notify_Cook_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Cook_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_cook_sub(inputs)
	return en_notify_cook_sub(inputs)
});